const features = [
    {
        id: 1,
        name: 'Calling Features',
        description: 'Calling features that give you wings',
        subDescription: 'Fast, accurate calling, complete tracking',
        subMenu: [
            {
                name: 'Auto Dialer', 
                description: 'For Faster, More Calls',
                image: 'calling_auto_dialer'
            },
            {
                name: 'Reminders', 
                description: 'So that you never miss a follow-up',
                image: 'calling_reminders'
            },
            {
                name: 'Tracking', 
                description: 'To see exactly what your team is doing',
                image: 'calling_tracking'
            },
            {
                name: 'Recording', 
                description: 'To track and log every conversation',
                image: 'calling_recording'
            },
        ]
    },
    {
        id: 2,
        name: 'Connect with leads',
        description: 'Connect with leads on their favourite platform',
        subDescription: 'With all the important WhatsApp features and automation',
        subMenu: [
            {
                name: 'Templates', 
                description: 'To send personalised messages to leads within seconds',
                image: 'connect_templates'
            },
            {
                name: '1-Click', 
                description: 'To send WhatsApp messages without saving numbers',
                image: 'connect_1_click'
            },
            {
                name: 'Official API', 
                description: 'To send WhatsApp messages with buttons',
                image: 'connect_official_api'
            },
            {
                name: 'Chatbot', 
                description: 'To engage with leads 24x7',
                image: 'connect_chatbot'
            },
            {
                name: 'Broadcasting', 
                description: 'To engage multiple leads in one click',
                image: 'connect_broadcasting'
            }
        ]
    },
    
    {
        id: 3,
        name: 'Get leads',
        description: 'Get leads from everywhere in one place',
        subDescription: 'With all the important WhatsApp features and automation',
        subMenu: [
            {
                name: 'Website', 
                description: 'Capture website leads in real-time',
                image: 'connect_templates'
            },
            {
                name: 'Facebook', 
                description: 'Capture and instantly engage with Facebook leads using CRM',
                image: 'connect_1_click'
            },
            {
                name: 'WhatsApp', 
                description: 'Capture leads from WhatsApp messages',
                image: 'connect_official_api'
            },
            {
                name: 'Others', 
                description: 'IndiaMart, Justdial and 16 other portals',
                image: 'connect_chatbot'
            },
        ]
    }
  ]; 
  
  export default features;
  